<template>
  <VueSvgGauge
    :start-angle="0"
    :end-angle="360"
    :value="(value / 100) * 360"
    :separator-step="0"
    :min="0"
    :max="360"
    :gauge-color="colors[0]"
    :base-color="colors[1]"
    :scale-interval="0"
  >
    <div class="inner-text">
      <v-container fluid fill-height>
        <v-flex>
          <v-row justify="center">
            <i :class="logo"></i>
          </v-row>
          <v-row justify="center">
            <span>{{ valueAsPercentage }}</span>
          </v-row>
        </v-flex>
      </v-container>
    </div>
  </VueSvgGauge>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    logo: {
      type: String,
      default: 'zmdi zmdi-bike',
    },
    colors: {
      type: Array,
      default: () => ['#e04074', '#f799d1'],
    },
  },
  data() {
    return {
      text: '1.5%',
    };
  },
  computed: {
    valueAsPercentage() {
      return `${this.value.toString()}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.inner-text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  color: black;
  font-weight: 700;
}
</style>
